<div class="row">
  <div class="col-md-4 col-12">
    <label for="CenterID" class="fs-14 fw-normal font-white">Select Center</label>
    <app-multi-select-dropdown
      label=""
      placeholder="Select Center"
      [isMultiSelect]="true"
      [items]="centerList"
      valueProperty="CenterID"
      displayProperty="CenterName"
      [(model)]="selectedCenters"
      (modelChange)="filterData()">
    </app-multi-select-dropdown>
  </div>

  <div class="col-md-4 col-12">
    <label for="ClassID" class="fs-14 fw-normal font-white">Select Class</label>
    <app-multi-select-dropdown
      label=""
      placeholder="Select Class"
      [isMultiSelect]="true"
      [items]="classList"
      valueProperty="ClassID"
      displayProperty="ClassName"
      [(model)]="selectedClasses"
      (modelChange)="filterData()">
    </app-multi-select-dropdown>
  </div>
</div>
<div class="row mb-4 mt-4">
  <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
    Students List
    <div class="border-green-bottom"></div>
  </div>
  <div class="col-md-6 col-12 d-flex justify-content-md-end mt-2">
    <div class="search-area">
      <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
      <input type="text" class="search-input" placeholder="Search Student" (keyup)="applyFilter($event)" #input />
    </div>
  </div>
</div>

<div>Total Student : {{ filteredStudentList?.length }}</div>
<div class="table-responsive-scroll">
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="w-100" matSort>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"> </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"> </mat-checkbox>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Status</th>
        <td mat-cell *matCellDef="let item" class="p-3">
          <span class="membership-pill" [style.background]="isRegistered(item.StudentID) ? '#053C21' : '#133a19'" [style.color]="isRegistered(item.StudentID) ? '#00B878' : '#717171'">
            {{ isRegistered(item.StudentID) ? "Registered" : "New" }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="FirstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">FirstName</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.FirstName }} {{ item.MiddleName }} {{ item.LastName }}</td>
      </ng-container>

      <ng-container matColumnDef="Gender">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Gender</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Gender || "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="MobileNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">MobileNo</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.MobileNo || "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="DOB">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">DOB</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ (item.DOB | date : "dd/MM/yyyy") || "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="Height">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Height</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Height || "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="Weight">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Weight</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Weight || "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="Email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Email</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Email || "-" }}</td>
      </ng-container>

      <ng-container matColumnDef="CenterName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3">Center</th>
        <td mat-cell *matCellDef="let item">
          <div class="fw-bold d-flex justify-content-center border-radius-10 p-2 fs-14 font-white bg-card-secondary">{{ item.center.CenterName }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="ClassName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3">Class</th>
        <td mat-cell *matCellDef="let item">
          <div class="fw-bold d-flex justify-content-center border-radius-10 p-2 fs-14 font-white bg-card-secondary">{{ item.CurrentActivePackage?.ClassName }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Address</th>
        <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Address || "-" }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- <mat-paginator [pageSizeOptions]="[10, 20]" [length]="length" showFirstLastButtons class="mt-3"></mat-paginator> -->
  </div>
</div>

@if(filteredStudentList?.length == 0){
<div class="mt-3 text-center">
  <div class="fs-16 fw-bold font-red-light">No Students Found</div>
</div>
} @if(filteredStudentList?.length > 0){
<div class="mt-4 d-flex gap-3 justify-content-end">
  <button type="submit" class="close-btn px-4 py-2" (click)="onClose()">Cancel</button>

  <button type="submit" class="add-btn px-4 py-2" (click)="onSubmit()">Submit</button>
</div>
}
